import * as tslib_1 from "tslib";
var AuthState_1;
import { State, Action, Store, Selector } from '@ngxs/store';
import { filter, take } from 'rxjs/operators';
import { JwtService } from '@app/utils/jwt.service';
const category = 'OAuth';
// eslint-disable-next-line
export var AuthStatus;
(function (AuthStatus) {
    AuthStatus["AUTH_INIT"] = "INIT";
    AuthStatus["AUTH_COMPLETE"] = "COMPLETE";
    AuthStatus["AUTH_VALID"] = "VALID";
    AuthStatus["AUTH_INVALID"] = "INVALID";
    AuthStatus["AUTH_NO_ACCESS"] = "NO_ACCESS";
    AuthStatus["AUTH_NO_REFRESH"] = "NO_REFRESH";
    AuthStatus["AUTH_REFRESHING"] = "REFRESHING";
    AuthStatus["AUTH_IN_PROGRESS"] = "IN_PROGRESS";
})(AuthStatus || (AuthStatus = {}));
export class ChangeStatus {
    constructor(status) {
        this.status = status;
    }
}
ChangeStatus.type = `[${category}] ChangeStatus`;
export class SetAuthData {
    constructor(url, scopes, user) {
        this.url = url;
        this.scopes = scopes;
        this.user = user;
    }
}
SetAuthData.type = `[${category}] SetAuthData`;
export class UpdateUser {
    constructor(user) {
        this.user = user;
    }
}
UpdateUser.type = `[${category}] UpdateUser`;
let AuthState = AuthState_1 = class AuthState {
    constructor(store, jwt) {
        this.store = store;
        this.jwt = jwt;
    }
    static status(state) {
        return state.status;
    }
    static baseURL(state) {
        return state.baseURL;
    }
    static hasScope(state) {
        return (scope) => state.scopes.indexOf(scope.split(':')[0]) >= 0 || state.scopes.indexOf(scope) >= 0;
    }
    static user(state) {
        return state.user;
    }
    changeStatus(ctx, action) {
        ctx.patchState({
            status: action.status,
        });
    }
    setAuthData(ctx, action) {
        ctx.patchState({
            baseURL: action.url,
            scopes: action.scopes,
            user: action.user,
        });
    }
    updateUser(ctx, action) {
        ctx.patchState({
            user: action.user,
        });
    }
    emitAuthComplete() {
        return this.store.select(AuthState_1.status).pipe(filter((status) => status === AuthStatus.AUTH_COMPLETE));
    }
    emitAuthInvalid() {
        return this.store.select(AuthState_1.status).pipe(filter((status) => status === AuthStatus.AUTH_INVALID));
    }
    baseURL() {
        return this.store.selectSnapshot(AuthState_1.baseURL);
    }
    userID() {
        return this.store.selectSnapshot(AuthState_1.user).id;
    }
    getUser() {
        return this.store.select(AuthState_1.user).pipe(filter((user) => !!user && user.id !== 0), take(1));
    }
};
tslib_1.__decorate([
    Action(ChangeStatus),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, ChangeStatus]),
    tslib_1.__metadata("design:returntype", void 0)
], AuthState.prototype, "changeStatus", null);
tslib_1.__decorate([
    Action(SetAuthData),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, SetAuthData]),
    tslib_1.__metadata("design:returntype", void 0)
], AuthState.prototype, "setAuthData", null);
tslib_1.__decorate([
    Action(UpdateUser),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, SetAuthData]),
    tslib_1.__metadata("design:returntype", void 0)
], AuthState.prototype, "updateUser", null);
tslib_1.__decorate([
    Selector([AuthState_1]),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], AuthState, "status", null);
tslib_1.__decorate([
    Selector([AuthState_1]),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], AuthState, "baseURL", null);
tslib_1.__decorate([
    Selector([AuthState_1]),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], AuthState, "hasScope", null);
tslib_1.__decorate([
    Selector([AuthState_1]),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], AuthState, "user", null);
AuthState = AuthState_1 = tslib_1.__decorate([
    State({
        name: 'auth',
        defaults: {
            status: AuthStatus.AUTH_INIT,
            baseURL: '',
            scopes: [],
            user: null,
        },
    }),
    tslib_1.__metadata("design:paramtypes", [Store, JwtService])
], AuthState);
export { AuthState };
